import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import Unsubscribe from "@/pages/Unsubscribe";
import SmoothScroll from "@/components/SmoothScroll";

function App() {
    return (
        <div className="App noise-overlay">
            <BrowserRouter>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <SmoothScroll>
                                <Home />
                            </SmoothScroll>
                        }
                    />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/account" element={<Account />} />
                    <Route
                        path="/unsubscribe/:token"
                        element={<Unsubscribe />}
                    />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
